import React from 'react';
import SelectDropdown from '../../components/ui/SelectDropdown';

const PAGE_SIZE_OPTIONS = [
  { value: '25', label: '25' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
];

export default function ServerTablePagination({
  total,
  limit,
  offset,
  onPageChange,
  onLimitChange,
  idPrefix = 'server-table',
}: {
  total: number;
  limit: number;
  offset: number;
  onPageChange: (nextOffset: number) => void;
  onLimitChange?: (nextLimit: number) => void;
  idPrefix?: string;
}) {
  const pageCount = Math.max(1, Math.ceil(total / limit));
  const pageIndex = Math.floor(offset / limit);
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);

  if (total <= limit && pageCount <= 1 && !onLimitChange) return null;

  return (
    <div className="bg-dark-surface px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 border-t border-dark-border sm:px-6">
      <p className="text-sm text-slate-300">
        Showing <span className="font-medium">{from}</span> to{' '}
        <span className="font-medium">{to}</span> of <span className="font-medium">{total}</span>
      </p>
      <div className="flex flex-wrap items-center gap-3">
        {onLimitChange ? (
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <span>Rows</span>
            <div className="w-20">
              <SelectDropdown
                id={`${idPrefix}-page-size`}
                value={String(limit)}
                onChange={(v) => onLimitChange(Number(v))}
                options={PAGE_SIZE_OPTIONS}
                compact
                ariaLabel="Rows per page"
              />
            </div>
          </label>
        ) : null}
        <nav
          className="inline-flex overflow-hidden rounded-xl border border-dark-border"
          aria-label="Pagination"
        >
          <button
            type="button"
            onClick={() => onPageChange(Math.max(0, offset - limit))}
            disabled={pageIndex <= 0}
            className="btn-secondary-mdl-sm relative inline-flex items-center rounded-none border-0 border-r border-dark-border disabled:opacity-50"
            aria-label="Previous page"
            id={`${idPrefix}-prev`}
          >
            Previous
          </button>
          <span className="inline-flex items-center bg-dark-elevated px-3 py-2 text-sm text-slate-300">
            Page {pageIndex + 1} of {pageCount}
          </span>
          <button
            type="button"
            onClick={() => onPageChange(offset + limit)}
            disabled={pageIndex >= pageCount - 1}
            className="btn-secondary-mdl-sm relative inline-flex items-center rounded-none border-0 border-l border-dark-border disabled:opacity-50"
            aria-label="Next page"
            id={`${idPrefix}-next`}
          >
            Next
          </button>
        </nav>
      </div>
    </div>
  );
}
